import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import _ from 'lodash';

import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, { FormBody, FormActions, TextInput } from '../../../Form';

@inject('imageTagStore')
@observer
class ImageTagEdit extends Component {
  // static propTypes = {
  // route: PropTypes.shape().isRequired,
  // params: PropTypes.shape({
  // id: PropTypes.string.isRequired,
  // }).isRequired,
  // tagStore: PropTypes.object.isRequired,
  // };

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  slug = '/idaq//image-tag';
  title = 'Edit Tag';
  disposer = null;
  @observable item = {
    name: '',
    description: '',
  };

  constructor(props) {
    super(props);

    const { params: { id }, imageTagStore } = props;

    imageTagStore.fetchItem(id);
  }

  componentWillMount() {
    this.reset();
  }

  @action reset() {
    const { params: { id }, imageTagStore } = this.props;
    const foundTag = imageTagStore.findById(id);
    if (foundTag) {
      this.item = _.pick(foundTag.asJson, ['id', 'name', 'description']);
    }
  }

  @action onChangeName = (e) => { this.item.name = e.target.value; }
  @action onChangeDescription = (e) => { this.item.description = e.target.value; }

  handleSave = (e) => {
    const { notify } = this.context;

    e.preventDefault();

    const { imageTagStore } = this.props;
    imageTagStore.updateItem(this.item)
        .then(() => {
          this.context.router.push(this.slug);
          notify.success();
        })
        .catch(err => { notify.error(err); });
  }

  render() {
    const { imageTagStore, params: { id } } = this.props;

    if (imageTagStore.isLoading) { return <Spinner />; }

    return (
        <Modal title={this.title} slug={this.slug} isSaving={imageTagStore.isSaving} handleSave={this.handleSave}>
          <Form>
            <FormBody>
              <TextInput label={'Id'} value={id} readOnly />
              <TextInput label={'Name'} value={this.item.name} onChange={this.onChangeName} />
              <TextInput label={'Description'} value={this.item.description} onChange={this.onChangeDescription} />
            </FormBody>

            <FormActions>
              <button onClick={this.handleSave}>Save</button>
            </FormActions>
          </Form>
        </Modal>
    );
  }
}

export default ImageTagEdit;



// WEBPACK FOOTER //
// ./src/components/IDaq/ImageTags/pages/ImageTagEdit.js